import React from "react";
import { Link } from "react-router-dom";

function ExploreLinks(props) {
  function getLastPartOfUrl(url) {
    const parts = url.split("/");
    return "/blog/" + parts[parts.length - 1];
  }

  return (
    <div className="p-4  flex-col">
      <div className="mt-0 text-[#000000B8] mb-4 text-lg flex justify-start text-start font-montserrat font-semibold">
        {props.heading}
      </div>
      <div className="flex justify-start">
        <div className="flex flex-col">
          {props.arr.map((linkText) => {
            if (props.isCalcList) {
              return (
                <Link to={`/${props.lang}/calculator/${linkText["id"]}`}>
                  <div className="text-[#4040FA] font-montserrat text-sm font-normal m-1 hover:cursor-pointer hover:text-black">
                    {linkText["title"]}
                  </div>
                </Link>
              );
            } else {
              return (
                <a href={getLastPartOfUrl(linkText.url)}>
                  <div className="text-[#4040FA] font-montserrat text-sm font-normal m-1 hover:cursor-pointer hover:text-black">
                    {linkText["title"]}
                  </div>
                </a>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
}
export default ExploreLinks;
